class AccountSettings.InstagramHashtagListeningTableView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/instagram_hashtag_listening_table_view"]

  className: 'instagram-listening-table'

  render:(@rowsToAdd) ->
    @$el.html(@template())
    _.each @rowsToAdd.models, (hashtag_listening) =>
      @addOneRow(hashtag_listening)
    _.each(@$el.find('select'), (select) =>
      $(select).chosen(width: "150px", disable_search: true)
    )
    @

  addOneRow:(listening_hashtag)->
    rowView = new AccountSettings.InstagramHashtagListeningRowView(listening_hashtag)
    @$el.find('#hashtags-list').append(rowView.render().el)
